import { render, staticRenderFns } from "./virus.vue?vue&type=template&id=7dbf08d8&scoped=true"
import script from "./virus.vue?vue&type=script&lang=js"
export * from "./virus.vue?vue&type=script&lang=js"
import style0 from "./virus.vue?vue&type=style&index=0&id=7dbf08d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf08d8",
  null
  
)

export default component.exports